export const { eventLoader } = window.o_global ?? {};
